// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nimg#media-img-table[data-v-f234f420] {\r\n  height: 50px;\n}\n[dir] img#media-img-table[data-v-f234f420] {\r\n  padding: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
